<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">File Manager</h5>
                  </div>
                  <small class="text-truncate text-muted">Last Update your drive: 29 Aug 2020</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <div class="btn-group" role="group" dropdown placement="bottom right">
                    <button type="button" class="btn btn-default dropdown-toggle" id="button-alignment" dropdownToggle
                      type="button" aria-controls="dropdown-alignment">New</button>
                    <div id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                      aria-labelledby="button-alignment">
                      <a class="dropdown-item" href="javascript:void(0);">
                        <input type="file" class="custom-file-input position-absolute">
                        Folder
                      </a>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" href="javascript:void(0);">
                        <input type="file" class="custom-file-input position-absolute">
                        File Upload
                      </a>
                      <a class="dropdown-item" href="javascript:void(0);">
                        <input type="file" class="custom-file-input position-absolute">
                        Folder Upload
                      </a>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" href="javascript:void(0);">Create Docs</a>
                      <a class="dropdown-item" href="javascript:void(0);">Create Sheets</a>
                      <a class="dropdown-item" href="javascript:void(0);">Create Slides</a>
                    </div>
                  </div>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">Folder</a>
                      <a class="dropdown-item" href="javascript:void(0)">File Upload</a>
                      <a class="dropdown-item" href="javascript:void(0)">Folder Upload</a>
                      <a class="dropdown-item" href="javascript:void(0)">Create Docs</a>
                      <a class="dropdown-item" href="javascript:void(0)">Create Sheets</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>

            </div>

          </div>

        </div>
      </div>
      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-4 py-2">
        <div class="container-fluid">

          <!-- Card: Drive status  -->
          <div class="row clearfix">
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="card mb-2">
                <div class="card-body">
                  <h5 class="mb-0">Google drive</h5>
                  <small class="info">15 GB ( Basic Plan )</small>
                  <div class="progress mb-0 mt-3" style="height: 6px;">
                    <div class="progress-bar bg-danger" data-transitiongoal="87" style="width: 87%;" aria-valuenow="87">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="card mb-2">
                <div class="card-body">
                  <h5 class="mb-0">Dropbox</h5>
                  <small class="info">2 GB ( Free Plan )</small>
                  <div class="progress mb-0 mt-3" style="height: 6px;">
                    <div class="progress-bar bg-warning" data-transitiongoal="53" style="width: 53%;"
                      aria-valuenow="53">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="card mb-2">
                <div class="card-body">
                  <h5 class="mb-0">OneDrive</h5>
                  <small class="info">1 TB ( Ragular Plan )</small>
                  <div class="progress mb-0 mt-3" style="height: 6px;">
                    <div class="progress-bar bg-success" data-transitiongoal="12" style="width: 12%;"
                      aria-valuenow="12">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <div class="card mb-2">
                <div class="card-body">
                  <h5 class="mb-0">FTP Drive</h5>
                  <small class="info">30 GB ( Regular plan )</small>
                  <div class="progress mb-0 mt-3" style="height: 6px;">
                    <div class="progress-bar" data-transitiongoal="21" style="width: 21%;" aria-valuenow="21"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Card: Folder  -->
          <div class="row clearfix">
            <div class="col-12">
              <div class="card mt-3">
                <div class="card-header">
                  <h6 class="card-title mb-1 fw-bold">Folder</h6>
                </div>
                <div class="card-body">
                  <div class="file_folder d-flex flex-wrap">
                    <a href="javascript:void(0);" class="p-3 mb-1 me-1 border d-flex">
                      <div class="icon me-3">
                        <i class="zmdi zmdi-folder zmdi-hc-2x text-muted"></i>
                      </div>
                      <div class="file-name">
                        <p class="mb-0 text-muted">Analytics</p>
                        <small>215 File, 50MB</small>
                      </div>
                    </a>
                    <a href="javascript:void(0);" class="p-3 mb-1 me-1 border d-flex">
                      <div class="icon me-3">
                        <i class="zmdi zmdi-folder zmdi-hc-2x text-muted"></i>
                      </div>
                      <div class="file-name">
                        <p class="mb-0 text-muted">Assets</p>
                        <small>815 File, 1.2GB</small>
                      </div>
                    </a>
                    <a href="javascript:void(0);" class="p-3 mb-1 me-1 border d-flex">
                      <div class="icon me-3">
                        <i class="zmdi zmdi-folder-star zmdi-hc-2x text-red"></i>
                      </div>
                      <div class="file-name">
                        <p class="mb-0 text-muted">Marketing</p>
                        <small>23 File, 22MB</small>
                      </div>
                    </a>
                    <a href="javascript:void(0);" class="p-3 mb-1 me-1 border d-flex">
                      <div class="icon me-3">
                        <i class="zmdi zmdi-folder zmdi-hc-2x text-info"></i>
                      </div>
                      <div class="file-name">
                        <p class="mb-0 text-muted">Web Project</p>
                        <small>67 File, 92MB</small>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Card: outside Heading  -->
          <div class="row clearfix">
            <div class="col-12">
              <div class="section_title d-md-flex justify-content-between mt-5">
                <div class="mb-2 me-3">
                  <h5 class="mb-0">Recently Accessed Files</h5>
                  <span class="text-muted text-truncate">Contrary to popular belief, Lorem Ipsum is not simply random
                    text</span>
                </div>
                <div class="mb-2">
                  <div class="btn-group" role="group" dropdown>
                    <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic" class=" btn
                      btn-default dropdown-toggle">All
                      Accessed</button>
                    <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                      aria-labelledby="button-basic">
                      <a class="dropdown-item" href="javascript:void(0);">Folder</a>
                      <a class="dropdown-item" href="javascript:void(0);">File</a>
                      <a class="dropdown-item" href="javascript:void(0);">PDF</a>
                      <a class="dropdown-item" href="javascript:void(0);">Doc file</a>
                    </div>
                  </div>
                  <button type="button" class="btn btn-danger"><i class="zmdi zmdi-delete"></i> <span
                      class="hidden-md">Recycle bin</span></button>
                </div>
              </div>
            </div>
          </div>

          <!-- Card: Recent Files table -->
          <div class="row clearfix">
            <div class="col-12">
              <div class="card mb-3">
                <div class="body">
                  <div class="table-responsive">
                    <table class="table table-hover text-nowrap mb-0">
                      <thead>
                        <tr>
                          <th class="border-top-0 "></th>
                          <th class="border-top-0 ">Name</th>
                          <th class="border-top-0 ">Share With</th>
                          <th class="border-top-0 ">Owner</th>
                          <th class="border-top-0 ">Last Update</th>
                          <th class="border-top-0 text-end">Size</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-folder zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">Work</span>
                          </td>
                          <td>
                            <div class="avatar-list avatar-list-stacked">
                              <img class="avatar xs rounded" src="assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip"
                                title="Avatar" />
                              <img class="avatar xs rounded" src="assets/images/xs/avatar2.jpg" data-bs-toggle="tooltip"
                                title="Avatar" />
                              <img class="avatar xs rounded" src="assets/images/xs/avatar3.jpg" data-bs-toggle="tooltip"
                                title="Avatar" />
                            </div>
                          </td>
                          <td style="width: 100px;">
                            <span>Me</span>
                          </td>
                          <td style="width: 100px;">
                            <span>Oct 7, 2018</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> - </span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-folder zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">Family</span>
                          </td>
                          <td>
                            -
                          </td>
                          <td style="width: 100px;">
                            <span>Me</span>
                          </td>
                          <td style="width: 100px;">
                            <span>Oct 17, 2018</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> - </span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-folder text-danger zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">Holidays</span>
                          </td>
                          <td>
                            -
                          </td>
                          <td style="width: 100px;">
                            <span>John</span>
                          </td>
                          <td style="width: 100px;">
                            <span>Oct 18, 2018</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> 50MB </span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-folder zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">Mobile Work </span>
                          </td>
                          <td>
                            -
                          </td>
                          <td style="width: 100px;">
                            <span>Me</span>
                          </td>
                          <td style="width: 100px;">
                            <span>April 7, 2019</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> 1GB </span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-folder zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">Photoshop Data</span>
                          </td>
                          <td>
                            <div class="avatar-list avatar-list-stacked">
                              <img class="avatar xs rounded" src="assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip"
                                title="Avatar" />
                              <img class="avatar xs rounded" src="assets/images/xs/avatar2.jpg" data-bs-toggle="tooltip"
                                title="Avatar" />
                            </div>
                          </td>
                          <td style="width: 100px;">
                            <span>Andrew</span>
                          </td>
                          <td style="width: 100px;">
                            <span>Nov 23, 2019</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> - </span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-folder text-danger zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">Holidays</span>
                          </td>
                          <td>
                            <div class="avatar-list avatar-list-stacked">
                              <img class="avatar xs rounded" src="assets/images/xs/avatar5.jpg" data-bs-toggle="tooltip"
                                title="Avatar" />
                              <img class="avatar xs rounded" src="assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip"
                                title="Avatar" />
                              <img class="avatar xs rounded" src="assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip"
                                title="Avatar" />
                              <img class="avatar xs rounded" src="assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip"
                                title="Avatar" />
                            </div>
                          </td>
                          <td style="width: 100px;">
                            <span>Me</span>
                          </td>
                          <td style="width: 100px;">
                            <span>Dec 5, 2018</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> 100MB </span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-file text-success zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">new timesheet.xlsx</span>
                          </td>
                          <td>
                            -
                          </td>
                          <td style="width: 100px;">
                            <span>Me</span>
                          </td>
                          <td style="width: 100px;">
                            <span>Dec 5, 2018</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> 52KB </span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-file-text text-warning zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">new project.doc</span>
                          </td>
                          <td>
                            -
                          </td>
                          <td style="width: 100px;">
                            <span>Me</span>
                          </td>
                          <td style="width: 100px;">
                            <span>May 5, 2019</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> 152KB </span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-collection-pdf text-warning zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">report.pdf</span>
                          </td>
                          <td>
                            -
                          </td>
                          <td style="width: 100px;">
                            <span>Me</span>
                          </td>
                          <td style="width: 100px;">
                            <span>May 2, 2019</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> 841KB </span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 50px;">
                            <i class="zmdi zmdi-collection-pdf text-warning zmdi-hc-lg"></i>
                          </td>
                          <td>
                            <span class="folder-name">report-2018.pdf</span>
                          </td>
                          <td>
                            -
                          </td>
                          <td style="width: 100px;">
                            <span>Me</span>
                          </td>
                          <td style="width: 100px;">
                            <span>Oct 16, 2018</span>
                          </td>
                          <td class="text-end">
                            <span class="size"> 541KB </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
